import { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import GroupsIcon from '@mui/icons-material/Groups';
import TDSMonthlySummary from './TDSMonthlySummary';
import TDSDeducteeDetails from './TDSDeducteeDetails';
import { pillTabsSx } from '../../Global/Styling';

const TDS_TABS = [
  { label: 'Monthly Summary', value: 0, icon: <CalendarMonthIcon /> },
  { label: 'Deductee Details', value: 1, icon: <GroupsIcon /> }
];

export default function TDS() {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box>
      <Tabs value={activeTab} onChange={(_, v) => setActiveTab(v)} sx={{ ...pillTabsSx, mb: 2 }}>
        {TDS_TABS.map((t) => (
          <Tab key={t.value} icon={t.icon} iconPosition="start" label={t.label} value={t.value} />
        ))}
      </Tabs>

      {activeTab === 0 && <TDSMonthlySummary />}
      {activeTab === 1 && <TDSDeducteeDetails />}
    </Box>
  );
}
